var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.99999C16.375 3.92642 16.5815 4.93909 16.5815 5.99999C16.5815 7.06089 16.375 8.07355 16 8.99999M18.8006 1C19.5674 2.50013 20 4.19955 20 5.99999C20 7.80043 19.5674 9.49984 18.8006 11M13 5.99999C13 8.20913 11.2091 9.99999 9 9.99999C6.79086 9.99999 5 8.20913 5 5.99999C5 3.79085 6.79086 1.99999 9 1.99999C11.2091 1.99999 13 3.79085 13 5.99999ZM5 14H13C15.2091 14 17 15.7908 17 18C17 19.1046 16.1046 20 15 20H3C1.89543 20 1 19.1046 1 18C1 15.7908 2.79086 14 5 14Z",
    stroke: "#717680",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlan);
export default __webpack_public_path__ + "static/media/userPlan.f690bb9357993469009bbdaf2620d8d4.svg";
export { ForwardRef as ReactComponent };